import { make3, types as T } from './action_types'
import * as API from '../services/api'
// set route path
export function setRoute(data) {
  return {
    type: T.SET_ROUTE,
    data
  }
}
// set login data
export function setUserInfo(data) {
  return {
    type: T.SET_USERINFO,
    data
  }
}
// clear login data called when logout press
export function clearData() {
  return {
    type: T.CLEAR_DATA
  }
}
// api method for load checklist types dropdown
export function loadEstimate(id, preview) {
  return {
    types: make3('LOAD_ESTIMATE'),
    promise: () => {
      return API.getProposal(id, preview).then(data => data)
    }
  }
}
